import { normalizeError } from 'core/common/errors';
import { AppThunk } from 'core/common/store';
import { updateUserPreferences } from './updateUserPreferences';

export const fetchUserInformation = (): AppThunk => async (dispatch, _, context) => {
  const { userService, loggingService: logger, heatmapRecordingService } = context;

  try {
    const data = await userService.getUserInformation();
    heatmapRecordingService.identify(data.email);

    dispatch(updateUserPreferences(data));
  } catch (e) {
    const err = normalizeError(e);
    logger.error(err);
    return null;
  }
};
